import NavigationItemPage from "types/globals/navigationBar/navigationItemPage";

const determineActiveLink = (
  item: NavigationItemPage,
  activeRoute: string | undefined
) => {
  return (
    activeRoute === "/" + item.uri ||
    activeRoute === "/" + item.uri + "/" ||
    (activeRoute === "/" && item.uri === "__home__")
  );
};

export default determineActiveLink;
